import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getOrderFormProductTypePartition } from "../../../http/api/MasterAPI";

const OrderFormProductTypePartitionSelect = ({ value, error, onChangeValue }) => {
  const [listOrderFormProductTypePartitionSelect, setListOrderFormProductTypePartitionSelect] = useState([]);
  
  async function getOrderFormProductTypePartitionSelect() {
    try {
      const response = await getOrderFormProductTypePartition();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          orderFormProductTypePartitionCd: element.varCd,
          orderFormProductTypePartitionName: element.varValue1,
        }))
        .filter(
          (x) => x.orderFormProductTypePartitionName && x.orderFormProductTypePartitionName.trim() !== ""
        );
      setListOrderFormProductTypePartitionSelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getOrderFormProductTypePartitionSelect();
  }, []);

  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("orderFormProductTypePartitionCd")}
      >
        <MenuItem
          key={"orderFormProductTypePartition" + 1}
          value={1}
        >
          する
        </MenuItem>
        <MenuItem
          key={"orderFormProductTypePartition" + 2}
          value={2}
        >
          しない
        </MenuItem>
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",marginLeft: 0 }}>{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default OrderFormProductTypePartitionSelect;
